import { Box, Typography } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { IApplicationState } from "../../redux/root-reducer";
import { ISensorData } from "../../safetySensors/types";
import { Alarm } from "./Alarm";
import styles from "./CurrentAlarms.module.scss";

export interface ICurrentAlarmsState {
  currentAlarms: ISensorData[];
}

const getCurrentAlarmsSelector = createSelector(
  (state: IApplicationState) => state.sensors,
  (sensorState) => ({
    currentAlarms: sensorState.sensorsWithAlerts,
  })
);

export const CurrentAlarms = () => {
  const { currentAlarms } = useSelector(getCurrentAlarmsSelector);
  const { t } = useTranslation();

  return (
    <Box sx={{ padding: 16 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <WarningIcon
          fontSize="large"
          className={
            currentAlarms.length < 1
              ? styles.warningIcon
              : styles.warningIconActive
          }
        />
        <Typography variant={"h1"}> {t("Current alarms")}</Typography>
      </Box>
      <div className={styles.alarmContainer}>
        {currentAlarms.length < 1 ? (
          <p className={styles.larmTextContainer}>
            {t("Currently there are no alarms")}
          </p>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              mt: 1,
              gridRowGap: 16,
            }}
          >
            {currentAlarms.map((a) => (
              <Alarm key={a.MeasuringDeviceID} currentAlarm={a} />
            ))}
          </Box>
        )}
      </div>
    </Box>
  );
};
